import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DocumentAttachDirectiveComponent} from './containers/document-attach';
import {DocumentService} from './services/document';
import {EffectsModule} from '@ngrx/effects';
import {DocumentEffects} from './effects/document';
import {DocumentDetailComponent} from './components/document-detail';
import {DocumentAttachFormComponent} from './components/document-attach-form';
import {DocumentListComponent} from './components/document-list';
import { DandPCoreModule } from '../core/dandp-core.module';
import { StoreModule } from '@ngrx/store';
import * as fromRoot from './reducers';

@NgModule({
  imports: [CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DandPCoreModule,
    EffectsModule.forFeature([DocumentEffects]),
    StoreModule.forFeature('document', fromRoot.reducers),
  ],
  declarations: [
    DocumentAttachDirectiveComponent,
    DocumentDetailComponent,
    DocumentAttachFormComponent,
    DocumentListComponent
  ],
  exports: [
    DocumentAttachDirectiveComponent,
    DocumentDetailComponent,
    DocumentListComponent
  ],
  providers: [
    DocumentService
  ]
})
export class DandpDocumentModule { }



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/document/dandp-document.module.ts